<template>
  <div class="action-table-cell">
    <v-btn v-if="runAction" :disabled="isButtonDisabled" large color="#11BA7F" class="run-config-action-btn">{{ $t('action.run') }}</v-btn>
    <v-btn v-else :disabled="isButtonDisabled" large color="#11BA7F" class="run-config-action-btn">{{ $t('action.mitigation.advisory') }}</v-btn>
  </div>
</template>

<script>
import { CONFIGURATION } from '@/constants/configuration';

export default {
  name: 'BucketActionTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isButtonDisabled() {
      return true;
    },
    runAction() {
      return this.item.status === CONFIGURATION.CLOUD_STATUS.private;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.action-table-cell {
  align-items: center;
  display: flex;

  .run-config-action-btn {
    font-family: $font-family-medium;
    font-size: $font-size-sm;
    height: 28px;
    width: 153px;
    border-radius: $radius-sm;
    color: white;
    box-shadow: $shadow-sm;
  }
}
</style>
